<template>

  <!--  <v-app-bar dense>-->
  <!--    <v-navigation-drawer v-model="sidebar">-->
  <!--      <v-list>-->
  <!--        <v-list-item-title-->
  <!--            v-for="item in routes"-->
  <!--            :key="item.link"-->
  <!--            :to="item.link">-->
  <!--          <v-list-item-action>-->
  <!--            <v-icon>{{ }}</v-icon>-->
  <!--          </v-list-item-action>-->

  <!--          <v-list-item-content>{{ item.title }}</v-list-item-content>-->
  <!--        </v-list-item-title>-->
  <!--      </v-list>-->
  <!--    </v-navigation-drawer>-->

  <!--    <v-toolbar>-->
  <!--      <span class="hidden-sm-and-up">-->
  <!--        <v-app-bar-nav-icon @click="sidebar = !sidebar">-->
  <!--        </v-app-bar-nav-icon>-->
  <!--      </span>-->
  <!--      <v-toolbar-title>-->
  <!--        <router-link to="/" tag="span" style="cursor: pointer">-->
  <!--          {{ "PoPWord" }}-->
  <!--        </router-link>-->
  <!--      </v-toolbar-title>-->
  <!--      <v-spacer></v-spacer>-->
  <!--      <v-toolbar-items class="hidden-xs-only">-->
  <!--        <v-btn-->
  <!--            text-->
  <!--            v-for="item in routes"-->
  <!--            :key="item.link"-->
  <!--            :to="item.link">-->
  <!--          <v-icon left dark>{{ }}</v-icon>-->
  <!--          {{ item.title }}-->
  <!--        </v-btn>-->
  <!--      </v-toolbar-items>-->
  <!--    </v-toolbar>-->

  <!--  </v-app-bar>-->

<!--  <span>
    <v-app-bar>
        <span class="hidden-sm-and-up">
        <v-app-bar-nav-icon @click="sidebar = !sidebar">
        </v-app-bar-nav-icon>
      </span>

      <v-toolbar-title>
        <router-link to="/" tag="span" style="cursor: pointer">
          {{ "PoPWord" }}
        </router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn
          text
          v-for="item in routes"
          :key="item.link"
          :to="item.link">
        <v-icon left dark>{{ }}</v-icon>
        {{ item.title }}
      </v-btn>


    </v-app-bar>

    <v-navigation-drawer
        v-model="sidebar"
        absolute
        bottom
        temporary
    >
      <v-list nav dense>
        <v-list-item-group>
          <v-list>
            <v-list-item-title
                v-for="item in routes"
                :key="item.link"
                :to="item.link">
              <v-list-item-action>
                <v-icon>{{ }}</v-icon>
              </v-list-item-action>

              <v-list-item-content>{{ item.title }}</v-list-item-content>
            </v-list-item-title>
          </v-list>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </span>-->

  <v-app-bar fixed app elevation="0">
    <v-toolbar-title>
      <router-link to="/">
        <img src="../assets/img/popword icon.svg" style="height: 40px" />
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn
        elevation="0"
        v-for="route in routes"
        :key="route.link"
        :to="route.link"
    >
      {{ route.title }}
    </v-btn>
    <v-btn elevation="0" v-on:click="logoutUser">{{ logout.title }}</v-btn>
    <div>
      <span class="text-subtitle2">{{ $auth.user.name }} </span>
      <v-avatar size="40">
        <img :src="$auth.user.picture" :alt="$auth.user.name" />
      </v-avatar>
    </div>
  </v-app-bar>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {

      routes: [
        { icon: "fas fa-user", title: "VocabLobby", link: "/" },
        { icon: "fas fa-user", title: "Stats", link: "/Stats" },
        { icon: "fas fa-user", title: "Dashboard", link: "/Dashboard" }
      ],
      logout: { icon: "fas fa-sign-out-alt", title: "Logout" }
    };
  },
  computed: {},
  methods: {
    logoutUser() {
      this.$auth.logout({returnTo: window.location.origin+"/ui/#/Login"});
      //this.$router.push({ path: "/" });
    }
  },
  components: {}
};
</script>
<style></style>
